import { render, staticRenderFns } from "./FormWizardVerticalIcon.vue?vue&type=template&id=415c38da&"
import script from "./FormWizardVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./FormWizardVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports